import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCrossedPlane = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <defs>
      <image
        width={64}
        height={62}
        id="crossed-plane_svg__a"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA+CAMAAACsn+1dAAAAAXNSR0IB2cksfwAAAMlQTFRF////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALJMpoAAAAEN0Uk5TAE1oSof/+y03xwHlaZfwGEepBvFJp98KV4kO+S63AmcZ/ncn1zAqzVSEIzvMBwPvlKphDenQ+L2FIs/0XYb6MT2wBMzkWToAAAFhSURBVHicrZfpVsIwEIVRCFCQCiiKgopoAfd9XxDe/6GgadJG0ga81/nJzPnOML2ZJZezbW09tHyKZ0UriNCKJRhQlgDhVVBApRoRNuAUahHA30QB9QggGiiguaUI2yihpQA7uyCgrQBiDwTsdxSg2AUJBzoF7xADHGkAKobesQb4PYzgxSmAYujHAFAMJwkAFMNpQsDEUEgAmBjKCcAthm4QBIOU33VTWCqGYRgwSnHUDIBLDGcy4Nx21A2ASwwXMuDyynLETWGJGK5vZMCt7WmZAIcY7qIIuwxtE+AQw72qk1WGh44JyBaDfniPT4v2/CsF2//y+iYJ7wK2j88Q8IUDxPd4DvghAGIyB0x9AlD9DwD9F+gisp+RFhItZfYx0c+Zbih0S6ObKt3Ws2zlwZJl9Ghjhys93ukFg11x6CWLXvPYRZNedellm1336YODPnnYo4s+++jDkz59/3R8zwBQ6jq/22r28wAAAABJRU5ErkJggg=="
      />
    </defs>
    <use href="#crossed-plane_svg__a" y={1} />
    <path
      d="M4.4 61.8 1.6 59 59.4 1.5l2.8 2.8z"
      style={{
        fill: 'red',
      }}
    />
  </svg>
);
const Memo = memo(SvgCrossedPlane);
export default Memo;
